import { Cluster, ClusterNodeNote } from "../models/Cluster";
import { PagedResults } from "../models/generics";
import client from "./axios";

const clustersUrl = `${window.__env.GATEWAY_URL}/v1/clusters`;
const notesUrl = `${window.__env.GATEWAY_URL}/v1/notes`;

export const Clusters = {
  getClusters: () => client.get<Cluster[]>(clustersUrl),
  createCluster: (body: FormData) => client.post<Cluster>(clustersUrl, body),
  editCluster: (id: number, fd: FormData) => client.put<Cluster>(`${clustersUrl}/${id}`, fd),
  removeCluster: (id: number) => client.delete(`${clustersUrl}/${id}`),
  getCluster: (id: number) => client.get<Cluster>(`${clustersUrl}/${id}`),
  getNotes: (params?: URLSearchParams) => client.get<PagedResults<ClusterNodeNote> | Array<ClusterNodeNote>>(notesUrl, { params }),
  editNote: (noteId: number, body: ClusterNodeNote) => client.put<any>(`${notesUrl}/${noteId}`, body),
  createNote: (body: ClusterNodeNote) => client.post<ClusterNodeNote>(`${notesUrl}`, body),
  deleteNote: (id: number) => client.delete(`${notesUrl}/${id}`),
}